/* eslint-disable no-plusplus */
/* eslint-disable no-continue */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-cycle */
import { getOperationName, getQueryDefinition } from '@apollo/client/utilities';
import { notification } from 'antd';
import { AxiosResponse } from 'axios';
import { INPUT_TYPE } from 'components/common/Input/types';
import { DEFAULT_FORMAT_DATE_INPUT_US, FORMAT_DATE } from 'constants/days';
import { ERRORS } from 'constants/notify';
import usStates from 'constants/usStates';
import { DocumentNode, FieldNode } from 'graphql';
import parsePhoneNumber, { isValidPhoneNumber } from 'libphonenumber-js';
import { get, isBoolean, isString } from 'lodash';
import moment from 'moment';
import qs from 'qs';
import { AuthAction } from 'redux/actions';
import AuthSelectors from 'redux/auth/auth.selectors';
import { INewInitalFieldsProps } from 'routes/Profile/components/ProfileContent/WithAddableInputFormTemplate/types';
import ApiEndpoint from 'services/api/apiEndpoint';
import AuthService from 'services/api/auth.service';
import { store } from 'store';
import { AppointmentStatus } from 'types/appointments';
import { IMessage, MessageStatus } from 'types/messages';
import { IAddress, TransactionStatusEnum } from 'types/transaction';
import {
  ContactNumberType,
  IContactType,
  IFileType,
  IOtherEmailType,
  IUser,
  IUserAddress,
  UserStatusEnum,
} from 'types/user';
import * as Yup from 'yup';

import { GeneralFunction, IUploadFile } from '../types/common';

Yup.addMethod(Yup.string, 'validatePhoneNumber', function (errorMessage = 'Error', required = true) {
  return this.test(`test-phone-number-format`, errorMessage, function (value) {
    const { path, createError } = this;

    if (required && (value || '').length === 0) {
      return createError({ path, message: 'Required' });
    }

    return !value || isValidPhoneNumber(value || '') || createError({ path, message: errorMessage });
  });
});

export const getLink = (path: string, params?: Record<string, string>) => {
  if (!params) {
    return path;
  }

  const requiredParams = path.replace(/:(\w+)/g, (_, param) => {
    if (!param || params[param] === undefined) {
      return _;
    }

    return params[param];
  });

  return requiredParams;
};

export const convertTimeToMinute = (time: string): number => {
  const [hour, minute] = time.split(':');
  return Number(hour) * 60 + Number(minute);
};

export const hasTouchScreenCheck = () => {
  let hasTouchScreen = false;
  if (navigator.maxTouchPoints) {
    hasTouchScreen = navigator.maxTouchPoints > 0;
  } else if (navigator.msMaxTouchPoints) {
    hasTouchScreen = navigator.msMaxTouchPoints > 0;
  } else {
    const mQ = window.matchMedia && window.matchMedia('(pointer:coarse)');
    if (mQ && mQ.media === '(pointer:coarse)') {
      hasTouchScreen = !!mQ.matches;
    } else if ('orientation' in window) {
      hasTouchScreen = true; // deprecated, but good fallback
    } else {
      // Only as a last resort, fall back to user agent sniffing
      const UA = navigator.userAgent;
      hasTouchScreen =
        /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) || /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
    }
  }
  return hasTouchScreen;
};

export const getNewQueryString = (baseQuery: string, queryObject: Record<string, any>): string => {
  const queryString = Object.entries(queryObject).reduce((accStr, [newQueryKey, newQueryValue]) => {
    const replacedValue =
      newQueryValue !== '' && newQueryKey !== '' && newQueryValue !== undefined && newQueryKey !== undefined
        ? `${newQueryKey}=${newQueryValue}`
        : '';
    let newAccStrValue = '';
    if (accStr.includes('?')) {
      const regExpStr = `(\\?|&)${newQueryKey}=([^&]*)`;
      const regExpObj = new RegExp(regExpStr);
      if (!regExpObj.test(accStr) && replacedValue) return `${accStr}&${newQueryKey}=${newQueryValue}`;
      if (accStr.includes(`?${newQueryKey}=`)) {
        newAccStrValue = accStr.replace(regExpObj, replacedValue ? `?${replacedValue}` : '');
      } else {
        const replacedValueIfAlreadyExisted = replacedValue ? `&${replacedValue}` : '';
        newAccStrValue = accStr.replace(regExpObj, replacedValueIfAlreadyExisted);
      }
      return newAccStrValue.replace(/^(\?&|&)/, '?');
    }
    return replacedValue ? `?${replacedValue}` : '';
  }, baseQuery);
  return queryString;
};

export const getUsStates = (state: any) => get(usStates, state);

export const getGraphQLQueryName = (query: DocumentNode) => {
  try {
    const def = getQueryDefinition(query);

    return (def.selectionSet.selections[0] as FieldNode).name.value;
  } catch (err) {
    console.log('OUTPUT ~ file: useGraphQLTable.ts ~ line 65 ~ getQueryName ~ err', err);
    return getOperationName(query);
  }
};

export const formatCurrency = (
  value: string | number,
  isHide = false,
  isHideCurrency = false,
  isShowPlus = false,
): string => {
  if (isHide) return '******';
  let formattedValue = '';

  try {
    if (!Number.isNaN(+value)) {
      formattedValue = new Intl.NumberFormat('en', {
        maximumFractionDigits: 2,
        ...(isHideCurrency
          ? {}
          : {
              style: 'currency',
              currency: 'USD',
            }),
        ...(isShowPlus
          ? {
              signDisplay: 'exceptZero',
            }
          : {}),
      }).format(+value);
    }
  } catch (error) {
    console.log('OUTPUT ~ file: utils.ts ~ formatNumber ~ error', error);
    return '';
  }

  return formattedValue;
};

export const prependZero = (value: number | string) => {
  const result = parseFloat(`${value}`);
  if (result && result < 10) {
    return `0${result}`;
  }
  return value;
};
// const { coordinate } = addressDetail;
// if (coordinate && coordinate[0] && coordinate[1]) {
//   const plusCodeLink = await MapService.getMapPlusCodeFromCoordinate(coordinate);
//   return plusCodeLink.data.plus_code.global_code;
// }
export const formatAddress = (addressDetail?: IAddress | IUserAddress | IUser, separateLines = false) => {
  if (!addressDetail) return undefined;
  const address = `${addressDetail.address1}${separateLines && addressDetail.address2 ? '\n' : ''}${
    addressDetail.address2 ? `, ${addressDetail.address2}` : ''
  }`;
  const { city } = addressDetail;
  const isCityMentioned = city?.toLowerCase().includes('city');
  const stateCode = addressDetail.state;
  const { zip } = addressDetail;
  const fullScheduleAddress = `${address}${separateLines ? '\n' : ''}${city}${isCityMentioned ? '' : ' City'}, ${get(
    usStates,
    stateCode || '',
  )} ${zip}`;
  return fullScheduleAddress;
};

export const hexToRgb = (hex: string, opacity?: number) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `rgba(${parseInt(result[1], 16)},${parseInt(result[2], 16)},${parseInt(result[3], 16)},${opacity || '1'})`
    : hex;
};
const avatarBackgroundColors = ['BC544B', '0492C2', '028A0F', 'A45EE5', '', 'E5379C', '241571']; // length 6
const getBackgroundIndex = (fullName: string): number => fullName.length % 6;
export const getDefaultAvatarUrl = (fullName: string, size = 50): string =>
  `https://ui-avatars.com/api/?name=${fullName}&background=${
    avatarBackgroundColors[getBackgroundIndex(fullName)]
  }&size=${size}&color=fff`;

export const fastGetDefaultAvatarUrl = (u?: IUser): string =>
  !u ? '' : u.avatar?.thumbnailPipeFrom || getDefaultAvatarUrl(`${u.firstName} ${u.lastName}`);

export const generateOtherEmailsInputFieldsProps = (
  otherEmails: IOtherEmailType[],
): { inputFieldProps: INewInitalFieldsProps; validationSchema: Record<string, any> } => {
  const emailValidationSchema: Record<string, any> = {};
  const inputFieldProps: INewInitalFieldsProps = {
    draggable: true,
    labelProps: ['Label', 'Email'],
    sizes: [12, 12],
    allowAddMore: true,
    allowAddMoreTemplate: {
      name: 'otherEmails-address',
      type: INPUT_TYPE.EMAIL,
      placeholder: 'Email',
      draggable: true,
      sideFields: [
        {
          name: 'otherEmails-type',
          label: 'Label',
          placeholder: 'Label',
        },
      ],
    },
    schemaTemplate: {
      'otherEmails-address': Yup.string().email('Invalid Email').required('Required'),
      'otherEmails-type': Yup.string().notRequired(),
    },
    inputProps: [
      {
        name: 'email',
        type: INPUT_TYPE.EMAIL,
        disabled: true,
        placeholder: 'Email',
        sideFields: [
          {
            name: 'emailType',
            label: 'Label',
            defaultValue: 'Primary & Sign-in',
            disabled: true,
            placeholder: 'Label',
          },
        ],
      },
    ],
  };
  const commonOtherEmailsFieldsInitialProps = {
    type: INPUT_TYPE.EMAIL,
    allowAddMore: true,
    placeholder: 'Email',
    draggable: true,
  };

  if (otherEmails.length > 0) {
    otherEmails?.forEach((email: IOtherEmailType, index) => {
      // change emailName to otherEmails-email-${index} once the schema is fixed
      const emailName = index === 0 ? 'otherEmails-address' : `otherEmails-address-${index}`;
      const emailTypeName = index === 0 ? 'otherEmails-type' : `otherEmails-type-${index}`;
      inputFieldProps.inputProps.push({
        ...commonOtherEmailsFieldsInitialProps,
        name: emailName,
        defaultValue: email.address,
        sideFields: [
          {
            name: emailTypeName,
            defaultValue: email.type,
            placeholder: 'Label',
          },
        ],
      });
      emailValidationSchema[emailName] = Yup.string().email('Invalid Email').required('Required');
      emailValidationSchema[emailTypeName] = Yup.string().notRequired();
    });
  }
  return { inputFieldProps, validationSchema: emailValidationSchema };
};

export const generateContactsInputFieldsProps = (contacts: IContactType[]) => {
  let inputFieldProps: any = {};
  const contactValidationSchema: Record<string, any> = {};
  // render list of emails fields and validations
  // render list of contacts fields and validations
  const commonContactInputProps: Partial<INewInitalFieldsProps> = {
    draggable: true,
    labelProps: ['Type', 'Label', 'Number'],
    sizes: [5, 5, 14],
    allowAddMore: true,
    required: true,
    isContact: true,
    allowAddMoreTemplate: {
      name: 'contacts-number',
      placeholder: 'Contact',
      defaultValue: '',
      draggable: true,
      sideFields: [
        {
          name: 'contacts-numberType',
          label: 'Number Type',
          type: INPUT_TYPE.SELECT,
          defaultValue: '',
          placeholder: 'Number Type',
          inputOptions: [
            { label: 'Cellphone', value: ContactNumberType.CELL },
            { label: 'Phone', value: ContactNumberType.PHONE },
            { label: 'Fax', value: ContactNumberType.FAX },
          ],
        },
        {
          defaultValue: '',
          name: 'contacts-type',
          placeholder: 'Label',
        },
      ],
    },
    schemaTemplate: {
      'contacts-number': Yup.string().required('Required'),
      'contacts-type': Yup.string().notRequired(),
      'contacts-numberType': Yup.string().required('Required'),
    },
    complexSchemaConverter: (schemaTemplate, id) => {
      const contactNumberInputName = `contacts-number-${id}`;
      const contactNumberTypeInputName = `contacts-numberType-${id}`;
      const contactsNumberTypeValidation = get(schemaTemplate, contactNumberInputName);
      if (!contactsNumberTypeValidation) return schemaTemplate;
      const convertedSchemaTemplate = {
        ...schemaTemplate,
        [`contacts-number-${id}`]: contactsNumberTypeValidation?.when(contactNumberTypeInputName, {
          is: (val: string) => val === ContactNumberType.PHONE || val === ContactNumberType.CELL,
          then: (c: any) => c.validatePhoneNumber('Wrong format'),
          otherwise: (c: any) => c.matches(/^[0-9]*$/, 'Number only'),
        }),
      };
      return convertedSchemaTemplate;
    },
  };

  if (contacts.length > 0) {
    contacts.forEach((contact: IContactType, index: number) => {
      const contactNumberName = `contacts-number-${index}`;
      const typeFieldName = `contacts-type-${index}`;
      const contactNumberTypeName = `contacts-numberType-${index}`;
      const contactProps = {
        name: contactNumberName,
        label: index === 0 ? 'Contact' : '',
        type: INPUT_TYPE.TEXT,
        allowAddMore: true,
        defaultValue: contact.number,
        placeholder: 'Contact',
        draggable: true,
        inputSettings: {
          isPhoneNumber:
            contact.numberType === ContactNumberType.CELL || contact.numberType === ContactNumberType.PHONE,
        },
        sideFields: [
          {
            name: contactNumberTypeName,
            label: 'Number Type',
            defaultValue: contact.numberType,
            type: INPUT_TYPE.SELECT,
            placeholder: 'Number Type',
            inputOptions: [
              { label: 'Cellphone', value: ContactNumberType.CELL },
              { label: 'Phone', value: ContactNumberType.PHONE },
              { label: 'Fax', value: ContactNumberType.FAX },
            ],
          },
          {
            name: typeFieldName,
            label: 'Label',
            defaultValue: contact.type,
            type: INPUT_TYPE.TEXT,
            placeholder: 'Label',
          },
        ],
      };
      if (index === 0) {
        inputFieldProps = {
          ...commonContactInputProps,
          inputProps: [contactProps],
        };
      } else {
        inputFieldProps.inputProps.push(contactProps);
      }
      contactValidationSchema[typeFieldName] = Yup.string().notRequired();
      contactValidationSchema[contactNumberTypeName] = Yup.string().required('Required');
      contactValidationSchema[contactNumberName] = Yup.string()
        .when(contactNumberTypeName, {
          is: (val: string) => val === ContactNumberType.PHONE || val === ContactNumberType.CELL,
          then: (c: any) => c.validatePhoneNumber('Wrong format'),
          otherwise: (c) => c.matches(/^[0-9]*$/, 'Number only'),
        })
        .required('Required');
    });
  } else {
    inputFieldProps = { ...commonContactInputProps, inputProps: [] };
  }
  return { inputFieldProps, validationSchema: contactValidationSchema };
};

export const convertExpireTime = (expiresIn?: string) => {
  if (expiresIn) {
    return Date.now() + parseFloat(expiresIn) * 1000;
  }
  return 0;
};

interface INotificationProps {
  success?: string | { message: string; duration: number };
  failure?: string | boolean | { message: string; duration: number };
}

export const defaultNotification = (props: INotificationProps) => {
  const { success, failure } = props;
  if (success) {
    notification.success(
      isString(success)
        ? {
            message: success,
            duration: 2,
          }
        : success,
    );
  }
  if (failure) {
    notification.error(
      isString(failure)
        ? {
            message: failure,
            duration: 2,
          }
        : isBoolean(failure)
        ? {
            message: ERRORS.DEFAULT_MUTATION_ERROR,
            duration: 2,
          }
        : failure,
    );
  }
};

export const getStatusColor = (status?: UserStatusEnum | TransactionStatusEnum | AppointmentStatus) => {
  switch (status) {
    case UserStatusEnum.ACTIVE:
    case TransactionStatusEnum.ACTIVE:
      return '#81D742';

    case TransactionStatusEnum.MATCHED:
      return '#1E73BE';

    case UserStatusEnum.DISABLED:
      return '#DD3333';

    case UserStatusEnum.REGISTERED:
      return '#F7CB73';

    case TransactionStatusEnum.CANCELLED:
    case AppointmentStatus.CANCELLED:
      return '#8c8c8c';

    default:
      return 'black';
  }
};

export const numberFormatter = (n: number, decimal?: number): string => {
  const finalDecimal = decimal || 1;
  if (Math.abs(n) > 1000000000) {
    return `${(n / 1000000000).toFixed(finalDecimal)}b`;
  }
  if (Math.abs(n) > 1000000) {
    return `${(n / 1000000).toFixed(finalDecimal)}m`;
  }
  if (Math.abs(n) > 1000) {
    return `${(n / 1000).toFixed(finalDecimal).replace(/[.,]0$/, '')}k`;
  }
  return `${n}`;
};

export const convertDateToISO = (date: string | Date): string => moment(date).toISOString();

export const checkExist = (arr: any[]): [boolean, any] => {
  let existElement = null;
  const exist = arr.some((e, ind) =>
    arr.some((eComp, indComp) => {
      if (ind !== indComp) {
        if (e && eComp && e === eComp) {
          existElement = e;
          return true;
        }
      }
      return false;
    }),
  );
  return [exist, existElement];
};

export const getFormattedDate = (date: string | Date) => {
  if (!date) return [undefined, undefined];
  const tempDate = moment(date, DEFAULT_FORMAT_DATE_INPUT_US);
  if (tempDate.isValid()) return [tempDate, DEFAULT_FORMAT_DATE_INPUT_US];
  return [moment(date, FORMAT_DATE), FORMAT_DATE];
};

export const getUpdatedDeletedFiles = (files: IUploadFile[], existedFiles: IUploadFile[]) => {
  if (files.length === 0) {
    return [[], existedFiles];
  }
  const updatedFiles: IUploadFile[] = [];
  const unchangedFiles: string[] = [];
  files.forEach((f) => {
    if (f.originFileObj) updatedFiles.push(f);
    else {
      unchangedFiles.push(f.uid);
    }
  });

  const deletedFiles = existedFiles.filter((f: IUploadFile) => !unchangedFiles.includes(f.uid));
  return [updatedFiles, deletedFiles];
};

export const convertFilesToDbFormat = (files: Array<IUploadFile>, extra?: Record<string, any>): Array<IUploadFile> =>
  files.map((f) => ({ name: f.name, type: f.type, documentId: f.documentId, uid: f.uid, size: f.size, ...extra }));

export const getFileUrl = (fileId: string): string => {
  const state = store.getState();
  const token = AuthSelectors.getAccessToken(state);
  return `${process.env.REACT_APP_BACKEND_URL}${ApiEndpoint.getDocument}?${qs.stringify({ token, id: fileId })}`;
};

export const getFileViewUrl = (fileId: string, token: string, name?: string): string =>
  `${process.env.REACT_APP_BACKEND_URL}${ApiEndpoint.getDocument}${
    name ? `/${encodeURIComponent(name)}` : ''
  }?${qs.stringify({ token, id: fileId })}`;

export const getFileDownloadUrl = (fileId: string, token: string): string =>
  `${process.env.REACT_APP_BACKEND_URL}${ApiEndpoint.downloadDocument}?${qs.stringify({ token, id: fileId })}`;

export const getFileExt = (fileName = ''): string | undefined => fileName.split('.').pop();

export const getFileType = (ext: string): string => {
  switch (ext) {
    case 'pdf':
      return 'PDF Document';
    case 'png':
    case 'jpg':
      return 'Image';
    default:
      return 'Unknown';
  }
};

export const shortenFileName = (fileName: string, length = 10): string => {
  const ext = getFileExt(fileName);
  let nameWithoutExt = fileName;
  if (ext) {
    nameWithoutExt = fileName.slice(0, fileName.lastIndexOf(`.${ext}`));
  }
  return `${nameWithoutExt.slice(0, length)}${length < nameWithoutExt.length ? '..' : ''}${ext ? `.${ext}` : ''}`;
};

export const formatFileSize = (size?: number): string => {
  let unit = 'Bytes';
  let fsize = size;
  if (!fsize) {
    return '';
  }
  if (fsize < 1024) {
    return `${fsize} ${unit}`;
  }
  unit = 'KB';
  fsize = Math.floor(fsize / 1024);
  if (fsize < 1024) {
    return `${fsize} ${unit}`;
  }
  unit = 'MB';
  fsize = Math.floor(fsize / 1024);
  if (fsize < 1024) {
    return `${fsize} ${unit}`;
  }
  unit = 'GB';
  fsize = Math.floor(fsize / 1024);
  return `${fsize} ${unit}`;
};

export const mapRight = <T = any>(collection: T[], callback: (a: T, index: number, all: T[]) => any) => {
  const result = [];
  for (let i = collection.length - 1; i >= 0; i -= 1) {
    result.push(callback(collection[i], i, collection));
  }
  return result;
};

export const getUnreadMessageCount = (messages: IMessage[]): number => {
  let count = 0;
  messages.forEach((message) => {
    if (message.status === MessageStatus.UNREAD) count += 1;
  });
  return count;
};

export const metersToMiles = (meters: number): number => meters * 0.000621371192;

export const formatListNames = (names: string[] = [], max = 3): string => {
  let ret = names.slice(0, names.length > max ? max : names.length).join(', ');
  if (names.length > max) {
    ret += ' and others';
  }
  return ret;
};

export const convertFilesToBrowserFormat = (files: IFileType[]) =>
  files.map((f) => ({
    uid: f.id,
    status: 'done',
    name: f.name,
    url: f.pipeFrom,
  }));

export const getNewAccessTokenUsingRefreshToken = (errorHandler?: GeneralFunction): Promise<AxiosResponse<any>> =>
  new Promise((resolve, reject) =>
    AuthService.getNewAccessToken()
      .then((response) => {
        const newAccessToken = response?.data?.accessToken;
        const newExpireTime = response?.data?.expiresIn;
        if (newAccessToken && newExpireTime) {
          store.dispatch(AuthAction.userSignInSuccess(newAccessToken, convertExpireTime(newExpireTime)));
        }
        resolve(response);
      })
      .catch((error) => {
        // No refresh or client token available, we force user to login
        console.log('token invalidate');
        store.dispatch(AuthAction.userSignOut());
        errorHandler?.(error);
        reject(error);
      }),
  );

export const getEncryptedFilesLinks = async (
  fileId: string,
  name?: string,
): Promise<{ viewUrl: string; downloadUrl: string }> => {
  const thresholdBySecond = 0;
  const state = store.getState();
  const { expires, accessToken } = AuthSelectors.selectAuth(state);
  let token = accessToken;
  if ((expires || 0) < Date.now() - thresholdBySecond * 1000) {
    const response = await getNewAccessTokenUsingRefreshToken();
    token = response.data.accessToken;
  }
  return new Promise((resolve) => {
    resolve({
      viewUrl: getFileViewUrl(fileId, token || '', name),
      downloadUrl: getFileDownloadUrl(fileId, token || ''),
    });
  });
};

export const formatPhoneNumber = (contactNumber?: string): string => {
  const phoneNumber = parsePhoneNumber(contactNumber || '');
  if (phoneNumber) {
    return phoneNumber.formatNational();
  }
  return contactNumber || '';
};

export function groupDataByElementProps<T extends Record<string, any>>(
  properties: (keyof T | { [key in keyof T]?: (value: T[key]) => string | number })[],
  data?: T[],
) {
  if (!data || data.length === 0 || properties.length === 0) return data;
  // store [{[properties]: index}] => for checking if the data with specified property is already set before, and which
  // index it is
  const dataByPropertiesWithIndex: Record<string, any>[] = [];
  return data.reduce((acc, d, dataIndex) => {
    // to get the accumulator's level depth, like acc[0][1][2] => to push the new data to the right depth
    let accumulateAccumulator = acc;
    // to check if accumulator is already set, if true, skip the push to accumulator step
    let isAlreadySetAccumulator = false;
    for (let propIndex = 0; propIndex < properties.length; propIndex++) {
      const prop = properties[propIndex];
      let dataPropValue;
      if (isString(prop)) {
        dataPropValue = d[prop];
      } else {
        const [dataPropKey, dataPropValueConverter] = Object.entries(prop)[0];

        dataPropValue = dataPropValueConverter(d[dataPropKey]);
      }
      const dataByPropIndex = dataByPropertiesWithIndex[propIndex]?.[dataPropValue];
      if (dataByPropIndex !== undefined) {
        accumulateAccumulator = accumulateAccumulator[dataByPropIndex];
        if (propIndex === properties.length - 1) {
          if (accumulateAccumulator) accumulateAccumulator.push(d);
          else accumulateAccumulator = [d];
        }
        continue;
      }
      dataByPropertiesWithIndex[propIndex] = {
        ...(dataByPropertiesWithIndex[propIndex] || {}),
        [dataPropValue]: dataIndex,
      };
      if (isAlreadySetAccumulator) continue;
      const newDataGroup = JSON.parse(
        `${'['.repeat(properties.length - propIndex)}${JSON.stringify(d)}${']'.repeat(properties.length - propIndex)}`,
      );
      if (accumulateAccumulator) accumulateAccumulator.push(newDataGroup);
      else accumulateAccumulator = [newDataGroup];
      isAlreadySetAccumulator = true;
    }
    return acc;
  }, [] as any[]);
}
